import React from "react";
import { AuthContext } from "../../lib/AuthContext";
import ParentComponent from "../../lib/ParentComponent";
import ar from "../../locale";
import { title } from "../../constants";
import FeminineVideos from "./Videos";
import FeminineNews from "./News";
import FeminineTraining from "./Training";

export default class Feminine extends ParentComponent {
  static contextType = AuthContext;

  constructor(props, context) {
    super(props, context);
    this.state = {
      user: context.user,
    };
  }

  componentDidMount() {
    super.componentDidMount();
    document.title = title + " - " + ar.womens_ball;
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  updateState = () => {
    this.setState((prev) => {
      return { ...prev };
    });
  };

  render() {
    let activeTab = this.props.match.params.key || "videos";
    return (
      <div className="page-wrapper">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card no-toolbar border-0">
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-9 mt-2">
                      <h2 className="card-title">{ar.womens_ball}</h2>
                      <h5 className="card-subtitle">
                        {ar.feminine_splash_heading}
                      </h5>
                    </div>
                    <div className="col-sm-3 mt-2 text-md-left"></div>
                  </div>
                  <div className="row">
                    <div className="col-12 mt-3">
                      <ul className="nav nav-tabs" role="tablist">
                        <li className="nav-item">
                          {" "}
                          <a
                            className={
                              "nav-link pl-4 pr-4 " +
                              (activeTab === "videos" ? "active" : "")
                            }
                            data-toggle="tab"
                            href="#videos"
                            role="tab"
                          >
                            <span className="hidden-sm-up"></span>{" "}
                            <span className="hidden-xs-down">{ar.videos}</span>
                          </a>{" "}
                        </li>
                        <li className="nav-item">
                          {" "}
                          <a
                            className={
                              "nav-link pl-4 pr-4 " +
                              (activeTab === "news" ? "active" : "")
                            }
                            data-toggle="tab"
                            href="#news"
                            role="tab"
                          >
                            <span className="hidden-sm-up"></span>{" "}
                            <span className="hidden-xs-down">{ar.news}</span>
                          </a>{" "}
                        </li>
                        <li className="nav-item">
                          {" "}
                          <a
                            className={
                              "nav-link pl-4 pr-4 " +
                              (activeTab === "training" ? "active" : "")
                            }
                            data-toggle="tab"
                            href="#training"
                            role="tab"
                          >
                            <span className="hidden-sm-up"></span>{" "}
                            <span className="hidden-xs-down">
                              {ar.training}
                            </span>
                          </a>{" "}
                        </li>
                      </ul>
                      <div className="tab-content tabcontent-border">
                        <div
                          className="tab-pane p-20 active"
                          id="videos"
                          role="tabpanel"
                        >
                          <FeminineVideos />
                        </div>
                        <div
                          className="tab-pane  p-20"
                          id="news"
                          role="tabpanel"
                        >
                          <FeminineNews />
                        </div>
                        <div
                          className="tab-pane p-20"
                          id="training"
                          role="tabpanel"
                        >
                          <FeminineTraining />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
